export enum NewItemDuration
{
  ZeroDays = '0',
  SevenDays = '7',
  FourteenDays = '14',
  TwentyOneDays = '21',
  ThirtyDays = '30',
  SixtyDays = '60',
  NinetyDays = '90'
}

export const availableNewItemDurations = [
  { key: NewItemDuration.ZeroDays, value: '0 days' },
  { key: NewItemDuration.SevenDays, value: '7 days' },
  { key: NewItemDuration.FourteenDays, value: '14 days' },
  { key: NewItemDuration.TwentyOneDays, value: '21 days' },
  { key: NewItemDuration.ThirtyDays, value: '30 days' },
  { key: NewItemDuration.SixtyDays, value: '60 days' },
  { key: NewItemDuration.NinetyDays, value: '90 days' },
];
